export default __webpack_public_path__ + "static/media/Accountdet.7faa2be1.svg";